import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "icon-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "desktop-bool" }
const _hoisted_6 = { class: "desktop-bool" }
const _hoisted_7 = {
  key: 0,
  class: "value"
}
const _hoisted_8 = {
  key: 1,
  class: "value"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "center" }
const _hoisted_12 = { class: "icon-container add" }
const _hoisted_13 = { class: "dropdown-row" }
const _hoisted_14 = { colspan: 6 }
const _hoisted_15 = { class: "table-dropdown" }
const _hoisted_16 = { class: "dropdown-heading show" }
const _hoisted_17 = { class: "dropdown-value show" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "dropdown-heading show" }
const _hoisted_20 = { class: "dropdown-value show" }
const _hoisted_21 = {
  key: 0,
  class: "value"
}
const _hoisted_22 = {
  key: 1,
  class: "value"
}
const _hoisted_23 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Boolean = _resolveComponent("Boolean")!
  const _component_TableDropdown = _resolveComponent("TableDropdown")!
  const _component_TableList = _resolveComponent("TableList")!

  return (_openBlock(), _createBlock(_component_TableList, {
    tableName: "videos",
    selectedRows: _ctx.selectedVideos,
    deselectedRows: _ctx.deselectedVideos,
    totalRows: _ctx.totalRows,
    showTableSelection: ""
  }, {
    colspan: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("colgroup", { class: "desktop-cols" }, [
        _createElementVNode("col", { style: {"width":"5%"} }),
        _createElementVNode("col", { style: {"width":"25%"} }),
        _createElementVNode("col", { style: {"width":"10%"} }),
        _createElementVNode("col", { style: {"width":"10%"} }),
        _createElementVNode("col", { style: {"width":"5%"} })
      ], -1),
      _createElementVNode("colgroup", { class: "mobile-cols" }, [
        _createElementVNode("col", { style: {"width":"15%"} }),
        _createElementVNode("col", { style: {"width":"75%"} }),
        _createElementVNode("col", { style: {"width":"5%"} })
      ], -1)
    ]))]),
    head: _withCtx(() => [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", {
          class: _normalizeClass({ hidden: _ctx.selectedVideos.length })
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("th", null, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (heading, index) => {
            return (_openBlock(), _createElementBlock("th", {
              key: heading.id,
              class: _normalizeClass(["sort", [
              heading.mobileFeatured ? 'primary' : 'secondary',
              {
                active: index === _ctx.headingsData.sortActiveIndex,
                sortable: heading.sortable,
                asc: _ctx.sortOrder === 'asc',
                desc: _ctx.sortOrder === 'desc',
                center: heading.center,
              },
            ]]),
              onClick: ($event: any) => (
              heading.sortable
                ? _ctx.handleClickSort(heading.title, heading.id)
                : null
            )
            }, [
              _createVNode(_component_TranslatedText, {
                path: heading.title
              }, null, 8, ["path"])
            ], 10, _hoisted_1))
          }), 128))
        ], 2)
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            (_ctx.preparedVideos[`video-${video.videoReference}`])
              ? (_openBlock(), _createElementBlock("tr", {
                  key: 0,
                  class: _normalizeClass(["row", {
              odd: _ctx.isOdd(i),
              active: _ctx.headingsData.rowActiveVideo === i,
            }])
                }, [
                  _createElementVNode("td", {
                    class: "center",
                    onClick: ($event: any) => (
                _ctx.handleClickCell(
                  video.id,
                  i,
                  video.videoReference,
                  video.textItems
                )
              )
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon",
                        icon: "video"
                      })
                    ])
                  ], 8, _hoisted_2),
                  _createElementVNode("td", {
                    class: "title",
                    onClick: ($event: any) => (
                _ctx.handleClickCell(
                  video.id,
                  i,
                  video.videoReference,
                  video.textItems
                )
              )
                  }, _toDisplayString(_ctx.findTextItem("title", video.textItems)), 9, _hoisted_4),
                  _createElementVNode("td", _hoisted_5, [
                    _createVNode(_component_Boolean, {
                      value: 
                  video.actionProgressObjects[0] &&
                  !!(
                    video.actionProgressObjects[0].viewed ||
                    video.actionProgressObjects[0].completed
                  )
                
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("td", _hoisted_6, [
                    (_ctx.getSignOffStatus(video.videoReference))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          _createVNode(_component_Boolean, {
                            value: 
                    video.actionProgressObjects[0] &&
                    !!(
                      video.actionProgressObjects[0].viewed &&
                      video.actionProgressObjects[0].completed
                    )
                  
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, "N/A"))
                  ]),
                  _createElementVNode("td", {
                    class: "td-button",
                    onClick: ($event: any) => (
                _ctx.handleClickCell(
                  video.id,
                  i,
                  video.videoReference,
                  video.textItems
                )
              )
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "right-arrow",
                      icon: "chevron-right"
                    })
                  ], 8, _hoisted_9)
                ], 2))
              : (_openBlock(), _createElementBlock("tr", {
                  key: 1,
                  class: _normalizeClass(["not-uploaded", { odd: _ctx.isOdd(i) }]),
                  onClick: ($event: any) => (_ctx.viewVideo(video.videoReference, video.textItems, video.id))
                }, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon",
                        icon: "plus"
                      })
                    ])
                  ]),
                  _createElementVNode("td", null, " Click to add " + _toDisplayString(_ctx.findTextItem("title", video.textItems)) + " here ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1))
                ], 10, _hoisted_10)),
            (
              _ctx.headingsData.rowActiveVideo === i &&
              _ctx.preparedVideos[`video-${video.videoReference}`]
            )
              ? (_openBlock(), _createBlock(_component_TableDropdown, { key: 2 }, {
                  wrapper: _withCtx(() => [
                    _createElementVNode("tr", _hoisted_13, [
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("table", _hoisted_15, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_16, [
                                _createVNode(_component_TranslatedText, { path: "references.viewed" })
                              ]),
                              _createElementVNode("td", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, [
                                  _createVNode(_component_Boolean, {
                                    value: 
                                video.actionProgressObjects[0] &&
                                !!(
                                  video.actionProgressObjects[0].viewed ||
                                  video.actionProgressObjects[0].completed
                                )
                              
                                  }, null, 8, ["value"])
                                ])
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_19, [
                                _createVNode(_component_TranslatedText, { path: "action.signed" })
                              ]),
                              _createElementVNode("td", _hoisted_20, [
                                (_ctx.getSignOffStatus(video.videoReference))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                      _createVNode(_component_Boolean, {
                                        value: 
                                video.actionProgressObjects[0] &&
                                !!(
                                  video.actionProgressObjects[0].viewed &&
                                  video.actionProgressObjects[0].completed
                                )
                              
                                      }, null, 8, ["value"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_22, "N/A"))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (
                      _ctx.viewVideo(video.videoReference, video.textItems, video.id)
                    )
                        }, [
                          _createVNode(_component_TranslatedText, { path: "common.video.view" })
                        ], 8, _hoisted_23)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["selectedRows", "deselectedRows", "totalRows"]))
}